/* eslint-disable camelcase */
import get from 'lodash/get';
import set from 'lodash/set';
import find from 'lodash/find';
import head from 'lodash/head';
import has from 'lodash/has';
import keys from 'lodash/keys';
import reduce from 'lodash/reduce';
import values from 'lodash/values';

const WEBSITE_MAP_PATH = 'settings.warehouse_website_map';
const MSI_MAP_PATH = 'settings.inventory_warehouse_source_map';
const USES_MSI_PATH = 'settings.inventory_uses_msi';

const geFormattedMap = ({ formData, path, label }) => {
    let map = get(formData, path);
    if (typeof map === 'string') {
        const initialMap = JSON.stringify({
            '': '',
        });
        map = JSON.parse(get(formData, path, initialMap));
    }

    return keys(map).map((warehouse_id) => ({
        warehouse_id,
        [label]: map[warehouse_id],
    }));
};

const geFormattedWebsiteMap = ({ formData, path }) => {
   let map = get(formData, path);
   
    if (typeof map === 'string') {
        const initialMap = JSON.stringify({});
        map = JSON.parse(get(formData, path, initialMap));
    }

    return keys(map).map((warehouse_id) => ({
        warehouse_id,
        website_id: get(map[warehouse_id], 'id', ''),
        website_code: get(map[warehouse_id], 'code', ''),
    }));
};

const getStringifyMap = ({ values: object, path, label }) => {
    const map = get(object, path, []);
    const formattedMap = reduce(
        map,
        (objectMap, pair) => {
            set(objectMap, pair.warehouse_id, pair[label]);
            return objectMap;
        },
        {},
    );

    return JSON.stringify(formattedMap);
};

const getStringifyWebsiteMap = ({ values: object, path }) => {
    const map = get(object, path, []);
    const formattedMap = reduce(
        map,
        (objectMap, pair) => {
            set(objectMap, pair.warehouse_id, {
                id: pair.website_id,
                code: pair.website_code,
            });
            return objectMap;
        },
        {},
    );

    return JSON.stringify(formattedMap);
};

export const prepareFormData = ({ formData }) => {
    set(formData, WEBSITE_MAP_PATH, geFormattedWebsiteMap({ formData, path: WEBSITE_MAP_PATH }));
    set(formData, MSI_MAP_PATH, geFormattedMap({ formData, path: MSI_MAP_PATH, label: 'source_code' }));
    set(formData, USES_MSI_PATH, Boolean(parseInt(get(formData, USES_MSI_PATH, '0'), 10)));
    return formData;
};

export const preparePayloadData = ({ values: object }) => {
    if (get(object, USES_MSI_PATH, false)) {
        set(object, MSI_MAP_PATH, getStringifyMap({ values: object, path: MSI_MAP_PATH, label: 'source_code' }));
    }

    set(object, WEBSITE_MAP_PATH, getStringifyWebsiteMap({ values: object, path: WEBSITE_MAP_PATH }));

    return object;
};

export const getDefaultDictionaryValue = ({ dictionary }) => {
    if (dictionary.length === 1) {
        return get(head(dictionary), 'value', '');
    }
    return '';
};

export const isWarehouseUsedMoreThanOne = ({ list = [], label = '' } = {}) => {
    const grouped = reduce(
        list,
        (result, pair) => {
            const { warehouse_id } = pair;
            if (!has(result, warehouse_id)) {
                set(result, warehouse_id, []);
            }
            result[warehouse_id].push(pair[label]);
            return result;
        },
        {},
    );

    return !!find(values(grouped), (websites) => websites.length > 1);
};
/* eslint-enable camelcase */
